import { getLangBasedDomain } from "../services/seoService";

export const getAppSettings = () => dispatch => {
    dispatch({
        payload: {
            paymentEnabled: false,
            languages: []
        },
        type: 'DOMAINS_BASED_ON_LANG',
    });
    getLangBasedDomain()
        .then(function (response) {
            // handle success
            dispatch({
                payload: response,
                type: 'DOMAINS_BASED_ON_LANG_SUCCESS',
            });
        })
        .catch(function (error) {
            // handle error
            dispatch({
                payload: error,
                type: 'DOMAINS_BASED_ON_LANG_ERROR',
            });
        });
};
